export default __webpack_public_path__ + "static/media/COMP-ETH.3e94bc40.svg";